module.exports = __webpack_public_path__ + "img/涞水红木家具.2a5e0ed1.jpg";